class VwGnlMesajDTO {
    id: number = 0;
    organizasyonId?: number = null;
    mesajtip?: number = 1;
    mesajturId?: number = null;
    muracaatId?: number = null;
    baslik?: string = "";
    icerik?: string = "";
    aktif?: string = "E";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptalKullanici?: number = null;
    iptalTarihi?: string = null;
    fkIptalneden?: number = null;
    hastaAdiSoyadi?: string = "";
    fkAlan?: number = null;
    mesajGonderen?: string = "";
    mesajAlanPersonel?: string = "";
    modulAdi?: string = "";
    fkAlanIds?: string = "";
}
export default VwGnlMesajDTO;